var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.meta.totalCount)?_c('button',_vm._g({staticClass:"flex items-center justify-between px-3 py-2 text-sm font-medium rounded-md w-full",class:[
    _vm.isCurrent
      ? 'bg-gray-200 text-gray-900'
      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
  ],attrs:{"type":"button"}},_vm.$listeners),[_c('span',{staticClass:"truncate"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.meta.totalSelectedCount)?_c('span',{staticClass:"inline-block py-0.5 px-3 text-xs rounded-full ml-2",class:[_vm.isCurrent ? 'bg-gray-50' : 'bg-gray-200 text-gray-600']},[_vm._v(" "+_vm._s(_vm.meta.totalSelectedCount)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }